import { Component, Input } from '@angular/core';
import { NgForm } from '@angular/forms';

import { AuthMethodsService } from '../auth-methods/auth-methods.service';
import { RegisterProps } from './register.model';

@Component({
  selector: 'app-register',
  templateUrl: './register.page.html',
  styleUrls: ['./register.page.scss'],
})
export class RegisterPage {
  showPassword = false;
  showRePassword = false;

  private _registerProps: RegisterProps = {
    usernameRequired: 'Username is required',
    emailInvalid: 'Enter a valid email',
    emailRequired: 'Email is required',
    passwordRequired: 'Password is required',
    confirmPasswordRequired: 'Confirm password is required',
    passwordsDoNotMatch: 'Passwords do not match',
    login: 'Login',
    signUp: 'Sign Up',
  };
  @Input() set registerProps(value: RegisterProps) {
    this._registerProps = { ...this.registerProps, ...value };
  }
  get registerProps(): RegisterProps {
    return this._registerProps;
  }

  constructor(private readonly authMethodsService: AuthMethodsService) {
    this.onRegister = this.onRegister.bind(this);
    this.authMethodsService.translations?.subscribe(translations => {
      this.registerProps = { ...this.registerProps, ...translations.register || {} };
    });
  }

  async onRegister(register: NgForm): Promise<void> {
    this.authMethodsService.registerPageService?.onRegister(register);
  }
}
